import { Routes } from '@angular/router';

import { requireAuth } from './core/auth/guards/auth.guard';

export const ROUTES_CONFIG: Routes = [
	{
		path: '',
		redirectTo: 'login',
		pathMatch: 'full',
	},
	{
		path: 'login',
		loadComponent: () => import('./core/auth/pages/login/login.component').then((m) => m.LoginComponent),
	},
	{
		path: 'subject',
		loadChildren: () => import('./modules/subject/subject.routes').then((m) => m.SUBJECT_ROUTES),
	},
	{
		path: 'control-object',
		loadChildren: () => import('./modules/control-object/control-object.routes').then((m) => m.CONTROL_OBJECT_ROUTES),
	},
	{
		path: 'event',
		loadChildren: () => import('./modules/event/event.routes').then((m) => m.EVENT_ROUTES),
	},
	{
		path: 'order',
		loadChildren: () => import('./modules/order/order.routes').then((m) => m.ORDER_ROUTES),
	},
	{
		path: 'report',
		loadChildren: () => import('./modules/report/report.routes').then((m) => m.REPORT_ROUTES),
	},
	{
		path: 'my-order',
		loadChildren: () => import('./modules/my-order/my-order.routes').then((m) => m.MY_ORDER_ROUTES),
	},
	{
		path: 'sanction',
		loadChildren: () => import('./modules/sanction/sanction.routes').then((m) => m.SANCTION_ROUTES),
	},
	{
		path: 'inspection',
		loadChildren: () => import('./modules/inspection/inspection.routes').then((m) => m.INSPECTION_ROUTES),
	},
	{
		path: 'admin',
		loadChildren: () => import('./modules/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
	},
	{
		path: 'account',
		loadChildren: () => import('./modules/account/account.routes').then((m) => m.ACCOUNT_ROUTES),
		canActivate: [requireAuth()],
	},
	{
		path: 'access-denied',
		loadComponent: () =>
			import('./core/auth/pages/access-denied/access-denied.component').then((m) => m.AccessDeniedComponent),
	},
	{
		path: '**',
		loadComponent: () =>
			import('./core/auth/pages/http-not-found404/http-not-found404.component').then((m) => m.HttpNotFound404Component),
	},
];
